import React, { useState, useEffect } from "react";
import { Redirect, Route, Link } from "react-router-dom";
import api from "services/api";
import DOMPurify from "dompurify";
import Banner from "elements/Banner";
import CustomerReviews from "elements/CustomerReviews";
import { Helmet } from "react-helmet";
import { __ } from "services/Translator";
import { Modal, Dropdown, Accordion } from "react-bootstrap";
import VipChart from "./VIP/VipChart";
import HomeFullBanner from "elements/HomeFullBanner";

export default function Vip(props) {
  const isAuthenticated = props.isAuthenticated;
  // const __ = (text) => text;
  const [pageContent, setPageContent] = useState({});

  const getResults = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "vip",
    });
    if (response.status === 200) {
      setPageContent(response.data.content_data);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  useEffect(() => {
    // getResults();
  }, []);

  const [showLargeImg, setShowLargeImg] = useState(false);

  const closeModal = () => {
    // setShowWalletModal(false);
    setShowLargeImg(false);
  };

  return (
    <>
      <Helmet>
        <title>
          {__("ChiliRojo | Become a VIP and get all the Rewards that go with it!")}
        </title>
        <meta
          name="description"
          content={__(
            "ChiliRojo! We value all our players of course, become a ViP though and get extra rewards, bonuses and more!"
          )}
        />
      </Helmet>
      {/* <Banner pageName="vip" {...props} /> */}
      {/* <section className="banner header-banner-area">
        <div className="single_banner_area">
          <img
            className="banner_bg desktop_banner"
            src={require("assets/chilirojo/images/vip/mhm-vip-large.jpg")}
          />

          <img
            className="banner_bg tab_banner"
            src={require("assets/chilirojo/images/vip/mhm-vip-medium.jpg")}
          />

          <img
            className="banner_bg mobile_banner"
            src={require("assets/chilirojo/images/vip/mhm-vip-small.jpg")}
          />

          <div className="container">
            <div className="banner_text_section vip_banner">
              <div className="vip_banner_text">
                {__(
                  "start playing today and get a invite to our exclusive vip club!"
                )}
              </div>
              {props.isAuthenticated ? (

                <Link
                  to="/games/live-games"
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                  className="commonBtn pTwoBtn mt-3 float-left"
                >
                  {__("Start Winning Now!")}
                </Link>
              ) : (
                <>
                  <Link
                    
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="commonBtn pTwoBtn mt-3 float-left"
                  >
                    {__("Start Winning Now!")}
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </section> */}
      <div className="container-xxl">
        <HomeFullBanner {...props} callFrom={"vip"} />
        <div className="terms_content vip_content">
          <div className="row">
            <div className="col-md-3 d-none">
              <div className="review_image">
                {/* <img
                    className="width_100"
                    src={require("assets/images/home/review.png").default}
                  /> */}
                <img
                  className="width_100"
                  src={require("assets/chilirojo/images/vip/mhm-vip.jpg")}
                />
              </div>
              <br />
            </div>
            <div className="col-md-12">
              {/* <div className="page_title">{pageContent?.page_title}</div>

                <div
                  className="paragraph white"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(pageContent.content),
                  }}
                ></div> */}

              <VipChart />

              <CustomerReviews isAuthenticated={props.isAuthenticated} />
              <br />
              {props.isAuthenticated || (
                <>
                  <center>
                    <div className="join_btn" >
                      <Link
                        className="commonBtn pTwoBtn "
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                          setTimeout(function () {
                            props.setModalSignUpPropsData(false);
                          }, 500);
                        }}
                      >
                        {__("Join Now")}
                      </Link>
                    </div>
                    <br />
                  </center>
                </>
              )}
            </div>
          </div>
        </div>
      </div>




      <Modal fullscreen={true} show={showLargeImg} onHide={closeModal}>
        <Modal.Body className="cashier_modal">
          <div onClick={closeModal} className="modal_close">
            <i className="fal fa-times"></i>
            {/* <img
              src={require("assets/chilirojo/images/icons/cross-icon.svg")}
              alt=""
            /> */}
          </div>
          <img

            style={{ width: "100%" }}
            src={require("assets/chilirojo/images/vip/vip-loyalty-chart.png")}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
